import { Text } from '@oneaudi/unified-web-components';
import { Footnote } from '~/components/footnotes/footnote-context';
import { FootnoteRendererStyle } from '~/components/footnotes/footnote-renderer-style';
import { useFootnotes } from '~/components/footnotes/use-footnote';
import { RenderHtml } from '~/components/text';

export const FootnoteRenderer = () => {
	const { getFootnotes } = useFootnotes();

	const footnotes = getFootnotes();

	if (footnotes.length === 0) {
		return <></>;
	}

	return (
		<FootnoteRendererStyle>
			{footnotes.map((footnote, index) => (
				<FootnoteComponent
					key={footnote.key}
					footnote={footnote}
					reference={String.fromCharCode(index + 'a'.charCodeAt(0))}
				/>
			))}
		</FootnoteRendererStyle>
	);
};

function FootnoteComponent({ reference, footnote }: { reference: string | number; footnote: Footnote }) {
	return (
		<>
			<span data-footnote-reference={reference}>
				<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>{reference}</Text>
			</span>
			<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>
				<RenderHtml html={footnote.value} />
			</Text>
		</>
	);
}

export function scrollToFootnote(reference: string | number) {
	const elements = document?.querySelectorAll(`[data-footnote-reference="${reference}"]`);
	if (elements?.length > 0) {
		elements.item(elements.length - 1).scrollIntoView({ behavior: 'smooth' });
	}
}
